<template>
  <div class="flex flex-col h-screen -mx-4 -mt-8">
    <Submenu
      :routes="routes"
      style="padding-bottom: 0 !important;"
      class="px-4 pt-2 bg-gray-100 bg-opacity-50"
    />
    <div class="flex-1 min-h-0 flex flex-col">
      <router-view />
    </div>
  </div>
</template>

<script>
import Submenu from '@/components/Submenu'

export default {
  name: 'Messages',
  components: {
    Submenu,
  },
  data() {
    return {
      routes: [
        {
          title: 'Nytt Meddelande',
          to: 'create',
        },
        {
          title: 'Skickade Meddelanden',
          to: 'archive',
        },
      ],
    }
  },
}
</script>

<style></style>
